export default __webpack_public_path__ + "static/media/img_vmware-colorBkg.29488472.png";